import React, { Component } from 'react';

// Externals
import axios from 'axios';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core';
import { withRouter } from "react-router-dom";
// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';
import AddOportunity from "./oportunities/AddOportunity";
// Material table
import MaterialTable from 'material-table'

// Material Kit
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
// import Button from "components/CustomButtons/Button.jsx";

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
// import withAuth from 'components/Auth/withAuth.jsx';

// import { cardTitleWhite, cardCategoryWhite } from "assets/jss/material-kit-pro-react.jsx";

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

class Properties extends Component {

  constructor(props) {
    super(props);
    this.state = {
      AddOportunityModal: false
    };
  }

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  handleClickDelete(oportunity) {

    window.confirm("You want to delete " + oportunity);

  }

  render() {
    const { classes } = this.props;
    const { confirm } = this.props;
    const { profile } = this.props;

    return (

        <div className={classes.root}>
        <Grid
          container
          spacing={8}
        >


          <Grid
            item
            lg={12}
            sm={12}
            xl={12}
            xs={12}
          >

                  <MaterialTable
                  columns={[
                    { title: 'Id', field: 'id' },
                    { title: 'Title', field: 'attributes.title' }, //, render: rowData => <img src={rowData.attributes.avatar} style={{width: 40, borderRadius: '50%'}}/> },
                    { title: 'Description', field: 'attributes.description' },
                    { title: 'Public', field: 'attributes.public', type: 'boolean' },
                    { title: 'Active', field: 'attributes.active', type: 'boolean' },


                  ]}
                  data={profile.attributes.deals}
                  title="Deals"
                  options={{
                    grouping: true,
                    search: true,
                    filtering: true,
                    exportButton: true,
                    actionsColumnIndex: 0
                  }}
                  actions={[
                              {
                                icon: 'forward',
                                tooltip: 'See details',
                                onClick: (event, rowData) => this.props.history.push('/deal/' + rowData.id )
                              },

                              {
                                icon: 'add',
                                tooltip: 'Add oportunity',
                                isFreeAction: true,
                                onClick: (event) => this.handleClickOpen("AddPropertyModal")
                              }
                            ]}
                  editable={{

                            onRowUpdate: (newData, oldData) =>
                              new Promise((resolve, reject) => {
                                setTimeout(() => {

                                  resolve();
                                }, 1000)
                              }),
                            onRowDelete: oldData =>
                              new Promise((resolve, reject) => {

                                setTimeout(() => {
                                  const { confirm } = this.props;
                                  let url = `${process.env.REACT_APP_API_URL}oportunities/` + oldData.id + '.json';
                                  axios
                                    .delete(url,{headers:{ Authorization: 'Bearer ' + confirm }})
                                    .then(response => {
                                      this.setState({ Updated: true });
                                    })
                                    .catch((error) => {
                                      console.log(error);
                                    });

                                  resolve()
                                }, 1000)
                              }),
                          }}


                />

            </Grid>

          </Grid>
          <AddOportunity handleClose={this.handleClose.bind(this)} isOpen={this.state.AddOportunityModal}/>
        </div>


    );
  }
}

Properties.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withStyles(styles),
  withRouter
)(Properties);
